import type { FC } from "react";
import type { IconName } from "../icons/icons";
import { cn } from "@/lib/styles.utils";
import { Icon } from "../icons/Icon";

interface IconButtonProps {
  icon: IconName;
  className?: string;
  iconClassName?: string;
  onClick: () => void;
}

const IconButton: FC<IconButtonProps> = ({
  icon,
  className,
  iconClassName,
  onClick,
}) => {
  return (
    <button
      data-testid={`icon-button-${icon}`}
      onClick={onClick}
      type="button"
      className={cn("rounded-full p-2", className)}
    >
      <Icon name={icon} className={cn("size-4", iconClassName)} />
    </button>
  );
};

export default IconButton;
